// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_Importer {
  box-sizing: border-box;
  line-height: 1.4;
}
.CSVImporter_Importer * {
  box-sizing: border-box;
}

body.CSVImporter_dragging {
  -webkit-user-select: none;
  user-select: none;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/Importer.scss"],"names":[],"mappings":"AAAA;EAEE,sBAAA;EACA,gBAAA;AAAF;AAEE;EACE,sBAAA;AAAJ;;AAMA;EACE,yBAAA;EACA,iBAAA;AAHF","sourcesContent":[".CSVImporter_Importer {\n  // base styling for all content\n  box-sizing: border-box;\n  line-height: 1.4;\n\n  * {\n    box-sizing: border-box;\n  }\n}\n\n// prevent text selection while dragging on mobile\n// (must be on body per https://www.reddit.com/r/webdev/comments/g1wvsb/ios_safari_how_to_disable_longpress_text_selection/)\nbody.CSVImporter_dragging {\n  -webkit-user-select: none; // needed for Safari\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
